module.exports = __webpack_public_path__ + "static/media/prev.7a6b1be1.svg";